import styled, { keyframes, css } from 'styled-components';
import { CircularProgress } from '@material-ui/core';

const fadeIn = keyframes`
  from {
      opacity: 0;
      transform: translateY(-20px);
  }
  to {
      opacity: 1;
      transform: translateY(0);
  }
`;

const ButtonStyle = css`
  cursor: pointer;
  animation: ${fadeIn} 1s;
  width: 100%;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 8px;

  background: ${props => props.theme.secundaria};
  border-radius: 8px;
  border: none;
  flex: 1;
  /* width: 100%; */

  height: 30px;
  color: #fff;

  transition: color 0.3s;
  transition: background-color 0.1s;

  &:hover {
    background-color: ${props => props.theme.secundariaShade};
  }

  &:active {
    background-color: ${props => props.theme.primaria};
  }

  svg {
    height: 20px;
    width: 20px;
    margin-right: 8px;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  animation: ${fadeIn} 2s;

  height: auto;
  overflow: hidden;

  span {
    animation: ${fadeIn} 1s;

    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;

    gap: 8px;

    width: 100%;

    @media (max-width: 768px) {
      flex-direction: column;
    }

    label {
      display: flex;
      align-items: center;
      align-self: center;

      @media (max-width: 768px) {
        align-self: flex-start;
      }

      input {
        appearance: none;
        width: 16px;
        height: 16px;
        border: 2px solid ${props => props.theme.secundaria};
        border-radius: 4px;
        background-color: white;
        cursor: pointer;
        transition:
          background-color 0.3s,
          border-color 0.3s;

        margin-right: 5px;

        :checked {
          background-color: ${props => props.theme.secundaria};
          border-color: ${props => props.theme.secundaria};
        }

        :checked::after {
          content: '✔';
          color: white;
          font-size: 12px;
          text-align: center;
          display: block;
          position: relative;
          top: -2px;
        }
      }
    }
  }

  .MuiTextField-root {
    /* contorno do input */
    & .MuiOutlinedInput-root {
      fieldset {
        &.MuiOutlinedInput-notchedOutline {
          border-color: ${props => props.theme.secundaria} !important;
        }
      }
    }
    /* Contorno do input no hover */
    &:hover {
      & .MuiOutlinedInput-root {
        fieldset {
          &.MuiOutlinedInput-notchedOutline {
            border-color: ${props => props.theme.secundariaShade} !important;
          }
        }
      }
    }
    /* contorno quando foca no input */
    & .MuiOutlinedInput-root {
      &.Mui-focused fieldset {
        border-color: ${props => props.theme.secundariaShade} !important;
      }
    }
    /* cor da fonte do input */
    & .MuiOutlinedInput-input {
      color: ${props => props.theme.texto} !important;
      /* letra maiúscula no input */
      text-transform: uppercase;
    }
    /* label quando preenchido */
    & label.MuiFormLabel-filled {
      color: ${props => props.theme.secundaria} !important;
    }
    /* label em cima do input */
    & label.Mui-focused {
      color: ${props => props.theme.secundariaShade} !important;
    }
    /* seria o placeholder */
    > label {
      color: ${props => props.theme.textoClaro};
    }
  }
`;

export const BotoesContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;

  margin-top: 8px;
`;

export const BotaoImprimir = styled.div`
  ${ButtonStyle}
`;

export const BotaoLimpar = styled.div`
  ${ButtonStyle}
`;

export const ContainerCheckbox = styled.div`
  margin-top: 15px;
  margin-right: 5px;

  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 768px) {
    margin-top: 0;

    width: 100%;

    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
`;

export const CirculoCarregandoDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const CirculoCarregando = styled(CircularProgress)`
  color: #e6e600 !important;
  color: ${props => props.theme.secundaria} !important;

  width: 80px !important;
  height: 80px !important;
  @media (max-width: 610px) {
    width: 40px !important;
    height: 40px !important;
  }
`;
